export default "/_next/static/chunks/fonts/MADEMirage-6f5bed796b1da476b6d3b8d81d5f1492.woff";